import { render, staticRenderFns } from "./custom-bread-crumb.vue?vue&type=template&id=4ce6387c"
import script from "./custom-bread-crumb.vue?vue&type=script&lang=js"
export * from "./custom-bread-crumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports